import { findDeploymentEnvFromUrl } from '@zooplus/commons-lang';

const isProd = () => {
    const currentEnv = findDeploymentEnvFromUrl();
    return currentEnv === 'prod';
};
const isBeta = () => {
    const currentEnv = findDeploymentEnvFromUrl();
    return currentEnv === 'beta';
};

export { isBeta, isProd };
//# sourceMappingURL=envService.js.map
